import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';

// Imports dos componentes MUI
import {
  Dialog, DialogActions, DialogContent, DialogTitle, TextField, Button, Box,
  InputAdornment, FormControlLabel, Switch
} from '@mui/material';

const PacoteModal = ({ open, onClose, onSave, pacoteParaEditar }) => {
  const [nome, setNome] = useState('');
  const [descricao, setDescricao] = useState('');
  const [dataInicial, setDataInicial] = useState('');
  const [dataFinal, setDataFinal] = useState('');
  const [valorTotal, setValorTotal] = useState(0);
  const [ativo, setAtivo] = useState(true);

  useEffect(() => {
    if (pacoteParaEditar && open) {
      setNome(pacoteParaEditar.nome || '');
      setDescricao(pacoteParaEditar.descricao || '');
      setDataInicial(pacoteParaEditar.dataInicial || '');
      setDataFinal(pacoteParaEditar.dataFinal || '');
      setValorTotal(pacoteParaEditar.valorTotal || 0);
      setAtivo(pacoteParaEditar.ativo !== undefined ? pacoteParaEditar.ativo : true);
    } else {
      // Reseta o formulário para um novo pacote
      setNome('');
      setDescricao('');
      setDataInicial('');
      setDataFinal('');
      setValorTotal(0);
      setAtivo(true);
    }
  }, [pacoteParaEditar, open]);

  const handleSaveClick = () => {
    if (!nome || !dataInicial || !dataFinal || valorTotal <= 0) {
      toast.error('Por favor, preencha todos os campos obrigatórios.');
      return;
    }

    const dadosDoPacote = {
      nome,
      descricao,
      dataInicial,
      dataFinal,
      valorTotal: parseFloat(valorTotal),
      ativo
    };
    onSave(dadosDoPacote);
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{pacoteParaEditar ? 'Editar Pacote' : 'Criar Novo Pacote'}</DialogTitle>
      <DialogContent dividers>
        <Box component="form" noValidate sx={{ mt: 1 }}>
          <TextField
            label="Nome do Pacote"
            fullWidth
            required
            margin="normal"
            value={nome}
            onChange={(e) => setNome(e.target.value)}
          />
          <TextField
            label="Descrição (Opcional)"
            fullWidth
            multiline
            rows={2}
            margin="normal"
            value={descricao}
            onChange={(e) => setDescricao(e.target.value)}
          />
          <Box sx={{ display: 'flex', gap: 2, mt: 1 }}>
            <TextField
              label="Data de Início"
              type="date"
              required
              fullWidth
              value={dataInicial}
              onChange={(e) => setDataInicial(e.target.value)}
              InputLabelProps={{ shrink: true }}
            />
            <TextField
              label="Data de Fim"
              type="date"
              required
              fullWidth
              value={dataFinal}
              onChange={(e) => setDataFinal(e.target.value)}
              InputLabelProps={{ shrink: true }}
            />
          </Box>
          <TextField
            label="Valor Total do Pacote"
            type="number"
            required
            fullWidth
            margin="normal"
            value={valorTotal}
            onChange={(e) => setValorTotal(e.target.value)}
            InputProps={{
              startAdornment: <InputAdornment position="start">R$</InputAdornment>,
            }}
          />
          <FormControlLabel
            control={<Switch checked={ativo} onChange={(e) => setAtivo(e.target.checked)} />}
            label={ativo ? "Pacote Ativo" : "Pacote Inativo"}
          />
        </Box>
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <Button onClick={onClose} variant="outlined">Cancelar</Button>
        <Button onClick={handleSaveClick} variant="contained">
          {pacoteParaEditar ? 'Salvar Alterações' : 'Criar Pacote'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PacoteModal;
